import { render } from "./Retail.vue?vue&type=template&id=db4436f0"
import script from "./Retail.vue?vue&type=script&lang=js"
export * from "./Retail.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Retail.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_41c50359%2Fpackages%2Finsurer%2Fsrc%2Fviews%2Fanalytics%2FRetail.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__